import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class AddToListHandler extends FormHandler {
    _prodIdInput = document.querySelector("[name='product_id']");
    _varIdInput = document.querySelector("[name='variation_id']");
    _variationWrap = document.querySelector(".variation-input-wrap");
    _qtyWrap = document.querySelector(".quantity-input-wrap");

    constructor(formElement) {
        super(formElement);

        this.listTable = document.getElementById("product_list_items");
        document
            .querySelector(".add-to-list-modal .ahx-search-holder")
            .addEventListener("click", this.getVariation.bind(this));
        this._variationWrap.addEventListener("change", this.variationChange.bind(this));
    }

    variationChange(e) {
        console.log(e.target.value);
        this._varIdInput.value = e.target.value;
    }

    async getVariation(e) {
        if (e.target.closest(".search-hit")) {
            e.preventDefault();

            let prodId = e.target
                    .closest(".search-hit")
                    .dataset.id.replace("product#", ""),
                prodTitle = e.target.closest(".search-hit").dataset.title,
                modalContent = e.target.closest(".modal-content"),
                submitBtn = modalContent.querySelector(
                    '.ahx-list-form [type="submit"]'
                ),
                prodDesc = modalContent.querySelector(".product-description");

            this._prodIdInput.value = prodId;
            this._varIdInput.value = 0;
            document.querySelector(".add-to-list-modal .ahx-search-results").style.display =
                "none";
            document.querySelector(".add-to-list-modal .ahx-show-more-container").style.display =
                "none";
            submitBtn.disabled = true;
            this._variationWrap.innerHTML = "";
            prodDesc.innerHTML = "";
            this._qtyWrap.innerHTML = "";

            modalContent.querySelector(".add-to-list-modal .ais-SearchBox-input").value =
                prodTitle;

            this.addSpinner();

            this.refreshVariation()
                .then((result) => {
                    if (result.variation_input) {
                        this._variationWrap.innerHTML = result.variation_input;

                        // https://stackoverflow.com/questions/2856513/how-can-i-trigger-an-onchange-event-manually
                        let selectElem =
                            this._variationWrap.querySelector("select");

                        selectElem.dispatchEvent(
                            new Event("change", { bubbles: true })
                        );
                    } else {
                        this._variationWrap.innerHTML = "";
                    }
                    if (result.quantity_input) {
                        this._qtyWrap.innerHTML = result.quantity_input;
                    } else {
                        this._qtyWrap.innerHTML = "";
                    }

                    prodDesc.innerHTML = result.description;

                    //modalContent.querySelector(".loading-wrap").remove();

                    //inputWrap.classList.remove("show-overlay");

                    this.removeSpinner();
                    submitBtn.disabled = false;
                    //submitBtn.classList.remove('disabled');
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (e.target.classList.contains("ais-SearchBox-reset")) {
            this._variationWrap.innerHTML = "";
            this._qtyWrap.innerHTML = "";
            prodDesc.innerHTML = "";
        }
    }

    async submitForm(event) {
        try {
            let item = await super.submitForm(event);

            // modalBody.classList.remove("show-overlay");
            // modalBody.lastElementChild.remove();

            this.listTable.insertAdjacentHTML("beforeend", item.row);
            this.listTable.lastElementChild.style.backgroundColor =
                "rgb(255, 228, 175, 0.2)";
        } catch (error) {
            console.log(error);
        }
    }

    async refreshVariation() {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("action", "ahx_wcpl_refresh_variation");
            formData.append(
                "product_id",
                document.querySelector("[name='product_id']").value
            );
            let queryStringParams = new URLSearchParams(formData);

            fetch(ahx_public.ajax_url, {
                method: "post",
                body: queryStringParams,
            })
                .then(function (response) {
                    return response.text();
                })
                .then(function (text) {
                    var returnData = JSON.parse(text);

                    resolve(returnData);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
